// extracted by mini-css-extract-plugin
export default {"Header":"HeaderSection_Header__Lj3nS"};